

import { useState } from "react"
import { Container, Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap"
import { Upload, X } from "lucide-react"
import AddEmployee from "../component/AddEmployee"
import { useParams } from "react-router-dom"
import AddBranch from "../component/AddBranch"
import AddDepartment from "../component/AddDepartment"
import AddDispute from "../component/AddDispute"
import AddDocument from "../component/AddDocument"

export default function AddEmployeeForm() {
 const {type} = useParams()

  return (
    <div className="page-content">
 
     {type==="emp"?( <AddEmployee/>):type === "branch"?<AddBranch/>:type === "department" ? <AddDepartment/>: type === "dispute"? <AddDispute/>: type === "document"? <AddDocument/>: null}

    </div>
  )
}
